import React, { type ComponentType, type JSXElementConstructor } from 'react';
import {
	type WithAnalyticsEventsProps,
	type UIAnalyticsEvent,
	withAnalyticsEvents,
} from '@atlaskit/analytics-next';
import { Field } from '@atlaskit/form';
import Select from '@atlaskit/select';
import Tooltip from '@atlaskit/tooltip';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages';
import type { DefaultAssigneeWithAnalyticsProps } from './types';
import { getDefaultAssigneeOptions } from './utils';

const DefaultAssignee = (props: DefaultAssigneeWithAnalyticsProps) => {
	const {
		intl: { formatMessage },
		onChange,
		allowUnassigned,
		createAnalyticsEvent,
		assigneeType,
	} = props;
	const defaultAssigneeOptions = getDefaultAssigneeOptions(formatMessage);
	const selectedAssigneeType = defaultAssigneeOptions.find((v) => v.value === assigneeType);
	const tooltipContent =
		allowUnassigned === true ? '' : formatMessage(messages.defaultAssigneeDisabledTooltip);
	const onMenuOpen = (): void => {
		const analyticsEvent: UIAnalyticsEvent = createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'dropdown',
		});
		fireUIAnalytics(analyticsEvent, 'defaultAssignee');
	};

	return (
		<Field name="default-assignee" label={formatMessage(messages.defaultAssigneeFieldLabel)}>
			{({ fieldProps }) => (
				<Tooltip content={tooltipContent} position="right">
					<Select
						inputId={fieldProps.id}
						options={defaultAssigneeOptions}
						value={selectedAssigneeType}
						// @ts-expect-error - TS2322 - Type '(arg1: AssigneeTypeOption) => void' is not assignable to type '(value: AssigneeTypeOption | null, action: ActionMeta<AssigneeTypeOption>) => void'.
						onChange={onChange}
						onMenuOpen={onMenuOpen}
						isDisabled={!allowUnassigned}
						menuPlacement="auto"
						classNamePrefix="atlaskit-select"
					/>
				</Tooltip>
			)}
		</Field>
	);
};
export { DefaultAssignee };

type DefaultAssigneeWithAnalyticsType = ComponentType<
	Omit<DefaultAssigneeWithAnalyticsProps, 'createAnalyticsEvent'>
>;

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const DefaultAssigneeWithAnalytics = withAnalyticsEvents()(
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	DefaultAssignee as unknown as JSXElementConstructor<WithAnalyticsEventsProps>,
) as DefaultAssigneeWithAnalyticsType;

export default injectIntl(DefaultAssigneeWithAnalytics);
